export const APP_CONFIG = {
  name: 'Reddy Pelli Sandhadi',
  domain: 'ReddyPelliSandhadi.com',
  supportEmail: 'support@reddypellisandhadi.com',
  maxPhotos: 4,
  maxPhotoSize: 5 * 1024 * 1024, // 5MB
  allowedImageTypes: ['image/jpeg', 'image/png', 'image/jpg'],
  maxDescriptionLength: 1000,
  offlineThreshold: 3 // months
};

export const DROPDOWN_OPTIONS = {
  maritalStatus: [
    { value: 'never-married', label: 'Never Married' },
    { value: 'divorced', label: 'Divorced' },
    { value: 'widowed', label: 'Widowed' }
  ],
  height: [
    { value: '4.6', label: '4\'6"' },
    { value: '4.7', label: '4\'7"' },
    { value: '4.8', label: '4\'8"' },
    { value: '4.9', label: '4\'9"' },
    { value: '4.10', label: '4\'10"' },
    { value: '4.11', label: '4\'11"' },
    { value: '5.0', label: '5\'0"' },
    { value: '5.1', label: '5\'1"' },
    { value: '5.2', label: '5\'2"' },
    { value: '5.3', label: '5\'3"' },
    { value: '5.4', label: '5\'4"' },
    { value: '5.5', label: '5\'5"' },
    { value: '5.6', label: '5\'6"' },
    { value: '5.7', label: '5\'7"' },
    { value: '5.8', label: '5\'8"' },
    { value: '5.9', label: '5\'9"' },
    { value: '5.10', label: '5\'10"' },
    { value: '5.11', label: '5\'11"' },
    { value: '6.0', label: '6\'0"' },
    { value: '6.1', label: '6\'1"' },
    { value: '6.2', label: '6\'2"' },
    { value: '6.3', label: '6\'3"' }
  ],
  complexion: [
    { value: 'very-fair', label: 'Very Fair' },
    { value: 'fair', label: 'Fair' },
    { value: 'wheatish', label: 'Wheatish' },
    { value: 'dark', label: 'Dark' }
  ],
  education: [
    { value: 'high-school', label: 'High School' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'diploma', label: 'Diploma' },
    { value: 'bachelors', label: 'Bachelor\'s Degree' },
    { value: 'masters', label: 'Master\'s Degree' },
    { value: 'phd', label: 'PhD' },
    { value: 'professional', label: 'Professional Degree' }
  ],
  occupation: [
    { value: 'student', label: 'Student' },
    { value: 'government', label: 'Government Employee' },
    { value: 'private', label: 'Private Employee' },
    { value: 'business', label: 'Business' },
    { value: 'professional', label: 'Professional' },
    { value: 'agriculture', label: 'Agriculture' },
    { value: 'homemaker', label: 'Homemaker' },
    { value: 'retired', label: 'Retired' },
    { value: 'others', label: 'Others' }
  ],
  annualIncome: [
    { value: '0-2', label: 'Up to 2 Lakhs' },
    { value: '2-5', label: '2-5 Lakhs' },
    { value: '5-10', label: '5-10 Lakhs' },
    { value: '10-15', label: '10-15 Lakhs' },
    { value: '15-25', label: '15-25 Lakhs' },
    { value: '25-50', label: '25-50 Lakhs' },
    { value: '50+', label: '50+ Lakhs' }
  ],
  nriCountries: [
    { value: 'usa', label: 'USA' },
    { value: 'uk', label: 'UK' },
    { value: 'australia', label: 'Australia' },
    { value: 'canada', label: 'Canada' },
    { value: 'germany', label: 'Germany' },
    { value: 'dubai', label: 'Dubai' },
    { value: 'others', label: 'Other Countries' }
  ],
  indianStates: [
    { value: 'andhra-pradesh', label: 'Andhra Pradesh' },
    { value: 'telangana', label: 'Telangana' },
    { value: 'karnataka', label: 'Karnataka' },
    { value: 'tamil-nadu', label: 'Tamil Nadu' },
    { value: 'kerala', label: 'Kerala' },
    { value: 'maharashtra', label: 'Maharashtra' },
    { value: 'gujarat', label: 'Gujarat' },
    { value: 'rajasthan', label: 'Rajasthan' },
    { value: 'madhya-pradesh', label: 'Madhya Pradesh' },
    { value: 'uttar-pradesh', label: 'Uttar Pradesh' },
    { value: 'bihar', label: 'Bihar' },
    { value: 'west-bengal', label: 'West Bengal' },
    { value: 'odisha', label: 'Odisha' },
    { value: 'punjab', label: 'Punjab' },
    { value: 'haryana', label: 'Haryana' },
    { value: 'delhi', label: 'Delhi' },
    { value: 'others', label: 'Others' }
  ]
};

export const VALIDATION_RULES = {
  phone: /^[6-9]\d{9}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  aadhaar: /^\d{12}$/,
  pan: /^[A-Z]{5}\d{4}[A-Z]$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/
};

export const ERROR_MESSAGES = {
  required: 'This field is required',
  invalidEmail: 'Please enter a valid email address',
  invalidPhone: 'Please enter a valid 10-digit mobile number',
  invalidAadhaar: 'Please enter a valid 12-digit Aadhaar number',
  invalidPan: 'Please enter a valid PAN number',
  weakPassword: 'Password must be at least 8 characters with uppercase, lowercase, and number',
  fileTooLarge: 'File size must be less than 5MB',
  invalidFileType: 'Only JPEG, JPG, and PNG files are allowed',
  maxPhotos: 'You can upload maximum 4 photos',
  maxLength: 'Maximum 1000 characters allowed'
};